const state = {
  deletingRowID: null
}
const getters = {
  getDeletingRowID: state => state.deletingRowID
}
const mutations = {
  setDeletingRowID(state, id) {
    state.deletingRowID = id
  }
}
  
export default {
  state,
  getters,
  mutations
}